import { Component, ViewEncapsulation, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core';
import { language, color, date, popover, ModalBase } from 'curvy';
import { date_time_translations } from './date-time-picker.trans';




@Component({
    selector: 'task-time-picker-dialog',
    template: `
		<div class="flex-column popover-date-time"
			[knwStyle]="{
				'--highlight': hl.color,
				'--highlight-text': hl.color_text,
				'--highlight-dark': hl.color_dark,
				'--highlight-dark-text': hl.color_dark_text,
				'--highlight-light': hl.color_light,
				'--highlight-light-text': hl.color_light_text
			}">
			<h3 class="date-time-header">{{ (injectedData.title || 'ENTER_TIME') | trans }}</h3>
			<task-time-picker [(in_datetime)]="datetime" (submit_date)="onsubmit()"></task-time-picker>

			
		</div>
		<div class="date-time-footer flex-row justify-space-between">
			<!-- <button class="pill" (click)="closePopover()"><i icon="clear"></i> <span>{{'CANCEL' | trans}}</span></button> -->
			<button class="pill filled" style="margin-left: auto;" (click)="onsubmit()"><i icon="done"></i> <span>{{'CONFIRM' | trans}}</span></button>
		</div>
		`,
    styleUrls: ['./date-time-picker.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TimePickerDialog extends ModalBase<{
    title?: string,
    in_datetime: Date,
    highlight?: string
}, Date> implements OnInit {

    datetime: Date;

    hl = color.make_color_variants("primary");


    closePopover() {
        popover.host.close();
    }

    onsubmit() {
        let timeToSubmit = this.datetime ?? new Date(); // NOT SURE IF THIS SHOULD HAPPEN HERE
        this.submit(timeToSubmit);
    }

    ngOnInit() {
        language.load_translations(date_time_translations);

        this.datetime = this.injectedData.in_datetime;
        if (this.injectedData.highlight !== undefined)
            this.hl = color.make_color_variants(this.injectedData.highlight);

    }
}
